import React from 'react';
import { Spinner } from 'components';

const SpinnerPage = () => {
  return (
    <div className='vertical-horizontal-align'>
      <Spinner size={100} />
    </div>
  );
};

export default SpinnerPage;



/** WEBPACK FOOTER **
 ** ./src/views/general/spinner-page.js
 **/